declare namespace $ {

	type $bog_max_list__rows_bog_max_select_1 = $mol_type_enforce<
		ReturnType< $bog_max_select['menu_content'] >
		,
		ReturnType< $bog_max_list['rows'] >
	>
	export class $bog_max_select extends $mol_select {
		filter_hint( ): string
		no_options_message( ): string
		Menu( ): $bog_max_list
	}
	
}

//# sourceMappingURL=select.view.tree.d.ts.map